import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import styles from './styles/ShopBreadcrumbs.scss';

function ShopBreadcrumbsComponent({ landingPage }) {
    return (
        <div className={styles.wrapper}>
            <a className={styles.breadcrumbLink} href="/">
                <FormattedMessage defaultMessage="Home" id="ShopBreadcrumbs.home" />
            </a>
            <span className={styles.breadcrumb}>{landingPage.title}</span>
        </div>
    );
}

ShopBreadcrumbsComponent.propTypes = {
    landingPage: PropTypes.object.isRequired,
};

export const ShopBreadcrumbs = createFragmentContainer(ShopBreadcrumbsComponent, {
    landingPage: graphql`
        fragment ShopBreadcrumbs_landingPage on LandingPage {
            title
        }
    `,
});
